import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useMemo } from "preact/hooks"

export default function FacetToggle({ facet, idPrefix, toggleData }) {
    const { toggleProductFilter } = useFacet(facet)
    const filter = facet.data.find(value => value.value.toLowerCase() === toggleData.valueName.toLowerCase());
    const inputId = `${idPrefix}-facet-${facet.id}-filter-quick-ship`;
    const headingId = `${idPrefix}-facet-heading-${facet.id}`;

    return ((filter && filter.count > 0) && (
        <div class="ns-quickship group/switch flex justify-between items-center flex-row-reverse">
            <div class="relative inline-block h-5 rounded-full cursor-pointer w-9">
                <input
                    id={inputId}
                    type="checkbox"
                    class="absolute w-full h-full transition-colors duration-300 rounded-full appearance-none cursor-pointer peer disabled:bg-t-background-secondary bg-p-neutral checked:bg-t-brand-primary peer-checked:border-t-border peer-checked:before:bg-t-border checked:disabled:bg-t-foreground-secondary" 
                    checked={filter.selected}
                    value={filter.value}
                    onChange={e => {
                        e.preventDefault()
                        toggleProductFilter(facet.field, filter.value, !filter.selected)
                    }}
                />
                <label
                    class="before:content[''] absolute top-2/4 left-1.5 h-3 w-3 -translate-y-2/4 cursor-pointer rounded-full border-none bg-t-background peer-disabled:bg-t-border shadow-md transition-all duration-300 before:absolute before:top-2/4 before:left-2/4 before:hidden before:h-10 before:w-10 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity hover:before:opacity-10 peer-checked:translate-x-full peer-checked:border peer-checked:border-solid peer-checked:border-t-ui-lines-2 peer-checked:before:bg-t-border"
                    htmlFor={inputId}
                />
            </div>
            <label htmlFor={inputId} class="mt-px cursor-pointer select-none">
                <div>
                    <h6 id={headingId} class="block p text-t-foreground group-has-[:disabled]/switch:text-t-disabled">
                        {facet.name}
                    </h6>
                </div>
            </label>
        </div>
    ))
}